module.exports = __webpack_public_path__ + "img/KG.6973254b.svg";